module.exports = __webpack_public_path__ + "img/首页二维码2.5052aa16.png";